import manager from 'app/module46/component-manager.js';

manager.register('show-password', (component, elements, attributes, properties) => {
	
	let timeout = null;
	
	const delay  = attributes['delay'] ?? 5000;
	const toggle = component.parentNode.querySelector('i');

	toggle.addEventListener('click', () => {

		clearTimeout(timeout);

		if(component.type === 'password') {
			component.type = 'text';
			if(delay) {
				timeout = setTimeout(() => { 
					component.type = 'password'; 
				}, delay);
			}
		} else {
			component.type = 'password';
		}
	});
});
